import { Laboratory } from '../models';
import { BaseRepository } from './BaseRepository';
import handleResponseError from './utils/handleResponseError';

export type AppointmentParams = {};

export default class AnalyticsRepository extends BaseRepository<any> {
  static review(params: {
    rating: number;
    review: string;
    laboratory: Laboratory;
  }) {
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...this.authHeader()
      },
      body: JSON.stringify({
        rating: params.rating,
        review: params.review,
        laboratory: params.laboratory.id
      })
    };

    return fetch(`${this.apiUrl}/review`, requestOptions)
      .then(this.handleResponse)
      .then(({ data }) => {
        return data;
      });
  }

  static handleResponse(response: Response) {
    return response.text().then((text: string) => {
      const res = text && JSON.parse(text);
      if (!response.ok) {
        const error = (res && res.message) || response.statusText;
        let errorString = '';

        if (res.errors) {
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          for (let [key, value] of Object.entries(res.errors)) {
            errorString += `${value}<br/><br/>`;
          }
        }

        handleResponseError(response, res, errorString || error);

        return Promise.reject(error);
      }

      return res;
    });
  }
}
